import React from 'react';
import { FaGlobe, FaUniversity, FaFlask, FaEnvelope } from 'react-icons/fa';
import './styles/Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__content">
        <div className="footer__copyright">
          <p>&copy; {new Date().getFullYear()} Teaming up team</p>
        </div>

        <div className="footer__links">
          <a className="footer__link" href="https://www.centropiaggio.unipi.it" target="_blank" rel="noopener noreferrer">
            <FaGlobe className="footer__icon" /> Centro E.Piaggio
          </a>

          <a className="footer__link" href="https://www.unipi.it/" target="_blank" rel="noopener noreferrer">
            <FaUniversity className="footer__icon" /> University of Pisa
          </a>

          <a className="footer__link" href="https://www.cnr.it/" target="_blank" rel="noopener noreferrer">
            <FaFlask className="footer__icon" /> Italian National Research Council
          </a>

          <a className="footer__link" href="mailto:caterina.giannetti@gmail.com">
            <FaEnvelope className="footer__icon" /> Contact Us
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;